import QTag from './src/tag';

export default QTag;
